import UpdateAdministrator from "../../../../components/@users/administrators/UpdateAdministrator";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AdministratorUpdatePage() {

    return (
        <UpdateAdministrator 
            routeType={routeTypes.admin}
        />
    )
}       